import { useDispatch, useSelector } from "react-redux";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { closeModal } from "/@src/redux/modal/actions";

function CustomModal({container = 'body'}) {
  const dispatch = useDispatch();
  const { modals } = useSelector((state) => state.modal);

  const closeCurrentModal = (id) => {
    dispatch(closeModal(id));
  };
  return (
    <>
      {modals.map((modal, i) => {
        const {
          id,
          isOpen,
          size,
          title,
          children,
          primaryButton,
          secondaryButton,
          placement,
          sticky,
        } = modal;
        let wrapperClasses = "";
        if (placement === "right") {
          wrapperClasses = "modal-right";
        }
        if (placement === "left") {
          wrapperClasses = "modal-left";
        }
        let toggle = undefined;
        if (!sticky) {
          toggle = () => closeCurrentModal(id);
        }
        return (
          <Modal
            isOpen={isOpen}
            toggle={toggle}
            size={size}
            key={i}
            id={id}
            wrapClassName={"modal-wrapper " + wrapperClasses}
            container={container}
          >
            <ModalHeader toggle={() => closeCurrentModal(id)}>
              {title}
            </ModalHeader>
            <ModalBody>{children}</ModalBody>
            {primaryButton && (
              <ModalFooter>
                {secondaryButton && (
                  <Button
                    color="secondary"
                    outline
                    onClick={secondaryButton.onClick}
                  >
                    {secondaryButton.title}
                  </Button>
                )}
                <Button
                  color={primaryButton.color || "primary"}
                  onClick={primaryButton.onClick}
                >
                  {primaryButton.title}
                </Button>
              </ModalFooter>
            )}
          </Modal>
        );
      })}
    </>
  );
}

export default CustomModal;
